<script>
    export default {
        name: 'SearchSelection',
        props: {
            value: {
                type: Array,
                default: () => []
            },
            items: {
                type: Array,
                default: () => []
            },
            title: {
                type: String,
                default: ''
            },
            hint: {
                type: String,
                default: ''
            },
            elevation: {
                type: String,
                default: '4'
            }
        },
        data() {
            return {
                selectedSearch: null,
                filterInput: ''
            }
        },

        computed: {
            headers() {
                return [
                    { text: this.$vuetify.lang.t('$vuetify.entity.name'), value: 'name' },
                    { text: this.$vuetify.lang.t('$vuetify.entity.description'), value: 'description' },
                    { text: this.$vuetify.lang.t('$vuetify.entity.sort'), value: 'sort', sortable: false },
                    { text: this.$vuetify.lang.t('$vuetify.entity.actions'), value: 'actions', sortable: false, align: 'end' }
                ]
            },
            tableConfig() {
                const singleSelect = _.has(this.$attrs, 'single-select')
                return {
                    items: this.items,
                    headers: this.headers,
                    itemKey: 'name',
                    sortBy: 'name',
                    search: this.filterInput,
                    dense: true,
                    showSelect: true,
                    singleSelect,
                    itemsPerPage: 5
                }
            },
            filter() {
                return {
                    dense: true,
                    hideDetails: true,
                    spellcheck: false,
                    clearable: true,
                    singleLine: true,
                    solo: true,
                    flat: true,
                    maxWidth: '200px',
                    style: 'max-width: 200px'
                }
            }
        },
        watch: {
            value(search) {
                this.selectedSearch = search
            },
            selectedSearch() {
                this.$emit('change', this.selectedSearch)
            }
        },

        created() {
            this.selectedSearch = this.value
        },

        methods: {
            setActiveRow(row, props) {
                props.isSelected ? props.select(false) : props.select()
            },
            deleteSearch(item) {
                this.$emit('delete', item)
            }
        }
    }
</script>

<template>
    <VSheet :elevation="elevation">
        <VToolbar dense flat>
            <VToolbarTitle>{{ title }}</VToolbarTitle>
            <VDivider class="mx-4" inset vertical/>
            <VSpacer/>
            <VTextField ref="filterInput" v-model="filterInput" v-bind="filter" :placeholder="$vuetify.lang.t('$vuetify.entity.filter')"/>
        </VToolbar>

        <VDataTable v-model="selectedSearch" v-bind="tableConfig" class="vc-search-selection-table px-2" @click:row="setActiveRow">
            <template slot="top">
                <div class="caption px-2 pb-4" v-text="hint"></div>
            </template>

            <!-- Sort -->
            <template v-slot:item.sort="{ item }">
                <div v.if="item.sort && item.sort.sortBy">{{ $vuetify.lang.t(`$vuetify.entity.${item.sort.sortBy}`) }}</div>
                <div v.if="item.sort && item.sort.sortDesc">{{ $vuetify.lang.t(`$vuetify.entity.${item.sort.sortDesc[0] ? 'desc' : 'asc'}`) }}</div>
            </template>

            <!-- Actions -->
            <template v-slot:item.actions="{ item }">
                <VIcon small class="ml-2 mdi mdi-delete" @click.left.stop="deleteSearch(item)"/>
            </template>
        </VDataTable>

        <VCardActions class="mt-2">
            <VSpacer/>
            <VBtn text @click.left="$emit('close')">{{ $vuetify.lang.t('$vuetify.actions.close') }}</VBtn>
        </VCardActions>
    </VSheet>
</template>

<style lang="scss">
    .vc-search-selection-table {
        table {
            tbody tr {
                cursor: pointer;
            }
        }
    }
</style>
